import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';
import rootReducer from './store';
import AppShell from './AppShell';
import { GlobalContext } from './context';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import { initBrandingFromCache, loadBranding } from './utils/branding'; // import './mock';

import AuthRoute from './AuthRoute'; // Page

import Login from './pages/auth/login';
import Forgot from './pages/auth/forgot'; // import Register from './pages/auth/register';

import Invite from './pages/invite/index'; // API

import { ApiGetUserInfo } from '@/api';
const store = createStore(rootReducer); // 首屏渲染前同步套用该域名缓存的白标品牌, 避免默认 Logo/标题闪一下

initBrandingFromCache(); // 公开页面(登录/忘记密码/邀请)不跟随主题切换, 始终保持浅色

const LIGHT_ONLY_ROUTES = /^\/(login|register|forgot|invite)(\/|$)/;
/**
 * 主题同步:
 *  - 公开页面强制 light;
 *  - 其余页面使用用户保存的主题;
 *  - 依赖 pathname, 因此客户端跳转(如退出登录回到 /login)也会重新应用。
 * 需渲染在 BrowserRouter 内部才能取到 location。
 */

function ThemeSync({
  theme
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    changeTheme(LIGHT_ONLY_ROUTES.test(pathname) ? 'light' : theme);
  }, [theme, pathname]);
  return null;
}

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'en-US');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;

      case 'en-US':
        return enUS;

      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userLoading: true
      }
    });
    ApiGetUserInfo(1).then(res => {
      console.log(res.data.data);
      store.dispatch({
        type: 'update-userInfo',
        payload: {
          userInfo: res.data.data,
          userLoading: false
        }
      });
    });
  }

  useEffect(() => {
    // 白标: 按当前访问的域名加载品牌(标题/图标/主色/Logo), 未配置则保持默认
    loadBranding();

    if (checkLogin()) {
      fetchUserInfo();
    }
  }, []);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/forgot",
    component: Forgot
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/invite",
    component: Invite
  }), /*#__PURE__*/React.createElement(AuthRoute, {
    path: "/",
    component: AppShell
  })), /*#__PURE__*/React.createElement(ThemeSync, {
    theme: theme
  })))));
}

ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));